import styled from '@emotion/styled';

export const Wrapper = styled.div`
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    padding: ${theme.spacing(2)} ${theme.spacing(3)} ${theme.spacing(4)};
    background-color: ${theme.colors.neutrals.grey9};
  `}

  ${({ theme }) => theme.media.showAt({ at: 2 })`
    padding: 0 ${theme.spacing(3)};
  `}

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    margin-top: ${theme.spacing(5)};
    display: flex;
    align-items: baseline;
  `}
`;

export const LinksWrapper = styled.div`
  display: flex;

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    margin: 0 -${theme.spacing(1)};
    padding-right: ${theme.spacing(2.5)};
  `}

  ${({ theme }) => theme.media.showAt({ at: 1 })`
    margin: -${theme.spacing(1)} -${theme.spacing(1.5)} 0;
  `}
`;

export const LinkInner = styled.div`
${({ theme }) => `
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${theme.colors.neutrals.grey11};
    border-radius: ${theme.borderRadius.round};
  `}

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    height: 56px;
    width: 56px;
    margin: 0 ${theme.spacing(1)};
  `}

  ${({ theme }) => theme.media.showAt({ at: 1 })`
    height: 34px;
    width: 34px;
    margin: 0 ${theme.spacing(1.5)};
  `}
`;
